import React from 'react';
import moment from 'moment';
import InfoTooltip from '../../../common/tooltip/info/index';
import { MANAGER } from '../../../../constants/roles';
import getCurrencySymbol from '../../../../constants/currencies';
import AccountingActionView from '../../../actions/view/accounting';
import { withNamespaces } from 'react-i18next';

const GeneralTableSubRow = (props) => {
  const { request, actionButtonEvents, t } = props;
  const { calculatedAmount } = request;

  return (
    <div className="row">
      <div className="col-md-first" />
      <div className="col-md-1" />
      <div className="col-md-2">
        <span>
          {request.employee.employeeName}
        </span>
      </div>
      <div className="col-md-2">
        <span>
          {moment(new Date(request.travelStartDate)).format('DD-MM-YYYY')}
          {' '}
          {request.travelStartHour}
        </span>
        <br />
        <span>
          {moment(new Date(request.travelEndDate)).format('DD-MM-YYYY')}
          {' '}
          {request.travelEndHour}
        </span>
      </div>
      <div className="col-md-2 ellipsis">
        <span>
          {request.travelReasons.map(reason => (
            <span key={reason.value}>
              {reason.label}
            </span>
          ))}
        </span>
      </div>
      <div className="col-md-1 ellipsis">
        {
                request.type === 'domestic'
                  ? (request.domestic.provinces.map(p => (
                    <span key={p.value}>
                      {' '}
                      {p.label}
                      {' '}
                    </span>
                  )))
                  : (
                    <span>
                      {request.abroad.country}
                    </span>
                  )
            }
      </div>
      <div className="col-md-1">
        <InfoTooltip info={t('travelExpenseGrossPayment')}>
          <span>
            {calculatedAmount.amount}
            {' '}
            {getCurrencySymbol(calculatedAmount.abroadCurrency)}
            {' '}
          </span>
        </InfoTooltip>
      </div>
      <div className="col-md-1">
        <InfoTooltip info={t('individualAccommodationAmount')}>
          <span>
            { calculatedAmount.individualAccommodationAmount
              ? calculatedAmount.individualAccommodationAmount
              : 0}
            {' '}
            {getCurrencySymbol(calculatedAmount.abroadCurrency)}
          </span>
        </InfoTooltip>
      </div>
      <div className="col-md-last">
        <AccountingActionView
          roles={[MANAGER]}
          actionButtonEvents={actionButtonEvents}
          request={request}
        />
      </div>
    </div>
  );
};

export default withNamespaces()(GeneralTableSubRow);



// WEBPACK FOOTER //
// ./src/components/accounting/table/sub-row/index.js